import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";

import styles from "./styles.css";

export default class SearchFailure extends PureComponent {
  render() {
    return (
      <div
        className={styles.searchFailure}
        data-test-id="filter-menu-search-failure"
      >
        {t("knowledge-verification.searchFailure")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/SearchFailure.js